"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RadioButton.css");
var RadioItem = /** @class */ (function (_super) {
    __extends(RadioItem, _super);
    function RadioItem(props) {
        var _this = _super.call(this, props) || this;
        _this._onChange = _this._onChange.bind(_this);
        return _this;
    }
    RadioItem.prototype._onChange = function () {
        var _a = this.props, value = _a.value, id = _a.id;
        this.props.onChange && this.props.onChange(value, id);
    };
    RadioItem.prototype._getInputProps = function () {
        var _a = this.props, id = _a.id, name = _a.name, value = _a.value, selectedValue = _a.selectedValue, isEnabled = _a.isEnabled, itemEnabled = _a.itemEnabled;
        var enabled = isEnabled && itemEnabled;
        return {
            id: id,
            name: name,
            value: value,
            type: 'radio',
            onChange: enabled ? this._onChange : void 0,
            checked: selectedValue === value,
            disabled: !enabled
        };
    };
    RadioItem.prototype._getLabelProps = function () {
        var _a = this.props, id = _a.id, label = _a.label, value = _a.value, buttonAlignment = _a.buttonAlignment, selectedValue = _a.selectedValue, children = _a.children;
        var classes = ['p-radio-item', 'p-bg-hv-child-af-primary50', "p-rb-align-" + buttonAlignment];
        if (selectedValue === value) {
            classes.push('checked');
        }
        return {
            className: classes.join(' '),
            htmlFor: id,
            'aria-label': children ? label : undefined
        };
    };
    RadioItem.prototype.render = function () {
        var _a = this.props, label = _a.label, children = _a.children;
        return (React.createElement("label", __assign({}, this._getLabelProps()),
            React.createElement("input", __assign({}, this._getInputProps())),
            React.createElement("span", { className: "p-bg-af-primary50" }),
            children || label));
    };
    RadioItem.defaultProps = {
        itemEnabled: true,
        buttonAlignment: 'middle'
    };
    return RadioItem;
}(React.Component));
exports.default = RadioItem;
//# sourceMappingURL=RadioItem.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/radio-button/build/control/RadioItem.js
// module id = 703
// module chunks = 0